import React, { useState, useEffect } from 'react';
import { Spinner, Alert, Button, ButtonGroup, Modal } from 'react-bootstrap';
import { useTheme } from '../../ThemeContext';
import SalesFeed from '../SalesFeed';
import { Link } from 'react-router-dom';
import { BsCartCheck, BsInfoCircle } from 'react-icons/bs';
import { API_URL } from '../../config/endpoints';

const getSoldCount = (item) => {
    const apiSoldCount = Number(item?.sold_count);
    if (Number.isFinite(apiSoldCount)) return Math.max(0, apiSoldCount);
    const col = Number(item?.col || 0);
    const col2 = Number(item?.col2 || 0);
    return Math.max(0, col - col2);
};

const YesterdaySales = ({ closeModals }) => {
    useEffect(() => {
        closeModals();
    }, [closeModals]);

    const { theme } = useTheme();
    const [salesData, setSalesData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedPeriod, setSelectedPeriod] = useState(1);
    const [showInfo, setShowInfo] = useState(false);
    const [soldTotal, setSoldTotal] = useState(0);

    const fetchSales = async (days) => {
        try {
            setLoading(true);
            setError(null);
            const response = await fetch(`${API_URL}/get_yesterday_sales?days=${days}`);
            const data = await response.json();

            if (data.status && data.data_sale) {
                const nextSales = Array.isArray(data.data_sale) ? data.data_sale : [];
                const apiSoldTotal = Number(data.sold_total);
                setSalesData(nextSales);
                setSoldTotal(Number.isFinite(apiSoldTotal)
                    ? Math.max(0, apiSoldTotal)
                    : nextSales.reduce((sum, item) => sum + getSoldCount(item), 0)
                );
            } else {
                setSoldTotal(0);
                setError('Не удалось загрузить данные о продажах');
            }
        } catch (err) {
            setSoldTotal(0);
            setError('Ошибка подключения к серверу');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchSales(selectedPeriod);
    }, [selectedPeriod]);


    return (
        <div className={`min-vh-100 yesterday-page-shell yesterday-safe-top ${theme === 'dark' ? 'yesterday-page-shell--dark' : 'yesterday-page-shell--light'}`}>
            <div className={`main-status-glass ${theme === 'dark' ? 'main-status-glass--dark' : 'main-status-glass--light'}`} aria-hidden="true" />
            <header className="sb-header">
                <Link className="sb-logo" to="/">
                    <img className="sb-logo-img" src="android-icon-36x36.png" alt="Salew Bot" width={36} height={36} />
                    <span>Salew Bot</span>
                </Link>



                {/* Центральная часть - заголовок */}
                <div className="yesterday-header-center">
                    <div className="yesterday-title-row">
                        <h1 className="fs-5 fw-bold mb-0">🔥 Подборка скидок</h1>
                        <span className="yesterday-sold-pill" title="Сколько товаров купили из этой подборки">
                            <BsCartCheck size={15} />
                            <span>Купили</span>
                            <strong>{soldTotal.toLocaleString('ru-RU')}</strong>
                            <span>шт.</span>
                        </span>
                    </div>
                    <Button
                        variant="link"
                        className="yesterday-info-btn"
                        onClick={() => setShowInfo(true)}
                        aria-label="Как формируется подборка"
                    >
                        <BsInfoCircle className="fs-5" />
                    </Button>
                </div>

            </header>

            {/* Кнопки периода */}
            <div className="content-wrapper">
                {/* Кнопки периода */}
                <div className="period-selector">
                    <ButtonGroup className="period-buttons shadow-sm">
                        <Button
                            variant={
                                selectedPeriod === 1
                                    ? 'primary'
                                    : theme === 'dark'
                                        ? 'outline-light'
                                        : 'outline-secondary'
                            }
                            onClick={() => setSelectedPeriod(1)}
                            className="text-nowrap fw-semibold"
                        >
                            За вчера
                        </Button>
                        <Button
                            variant={
                                selectedPeriod === 7
                                    ? 'primary'
                                    : theme === 'dark'
                                        ? 'outline-light'
                                        : 'outline-secondary'
                            }
                            onClick={() => setSelectedPeriod(7)}
                            className="text-nowrap fw-semibold"
                        >
                            За неделю
                        </Button>
                    </ButtonGroup>
                </div>

                {/* Контент */}
                <div className="yesterday-feed-wrap">
                    {loading ? (
                        <div className="loading-spinner">
                            <Spinner
                                animation="border"
                                variant={theme === 'dark' ? 'light' : 'dark'}
                            />
                        </div>
                    ) : error ? (
                        <Alert variant="danger" className="error-alert">
                            {error}
                        </Alert>
                    ) : (
                        <SalesFeed sales={salesData} type="yesterday" />

                    )}
                </div>
            </div>

            {/* Модальное окно с описанием */}
            <Modal show={showInfo} onHide={() => setShowInfo(false)} centered className={theme === 'dark' ? 'text-white modal-dark' : 'text-dark modal-light'}>
                <Modal.Header closeButton className={
                    theme === 'dark'
                        ? 'border-bottom border-secondary bg-dark text-white'
                        : 'border-bottom border-secondary bg-light text-black'
                }
                    style={{
                        background:
                            theme === 'dark'
                                ? 'linear-gradient(135deg, #2a2a2a, #1e1e1e)'
                                : 'linear-gradient(135deg, #fff, #f8f9fa)',
                        padding: '12px',
                        borderTopLeftRadius: '8px',
                        borderTopRightRadius: '8px',
                    }}>
                    <Modal.Title style={{ fontWeight: 'bold', fontSize: '1.1rem', textShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>Как формируется подборка</Modal.Title>
                </Modal.Header>
                <Modal.Body className={theme === 'dark' ? 'bg-dark text-white' : 'text-black bg-light'}
                    style={{
                        padding: '12px',
                        background:
                            theme === 'dark'
                                ? 'linear-gradient(135deg, #2a2a2a, #1e1e1e)'
                                : 'linear-gradient(135deg, #fff, #f8f9fa)',
                        borderRadius: '0',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                        color: theme === 'dark' ? '#fff' : '#333',
                        fontSize: '1rem',
                        lineHeight: '1.6',
                    }}>
                    <p className="mb-2">
                        В подборку попадают&nbsp;товары с остатком&nbsp;≥&nbsp;5&nbsp;шт. и
                        максимальным выкупом по многопараметрическому алгоритму
                        (учитываются&nbsp;продажи, категории, размер&nbsp;скидки и&nbsp;др.).
                    </p>
                    <p className="fst-italic mb-0 opacity-75">
                        «Вишенки» с остатком&nbsp;≤&nbsp;5&nbsp;шт. и&nbsp;другие жирные скидки
                        остаются в общей ленте — они часто ещё выгоднее, но автоматике их
                        сложнее оценить, поэтому в подборку попадает не всё.
                    </p>
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default YesterdaySales;
